<template>
    <CategoryForm :url="url" :model="model" :errors="errors" v-on:save="saveCategory"></CategoryForm>
</template>

<script>
import CategoryForm from './CategoryForm'
export default {
  name: 'CategoryCreate',
  components: {CategoryForm},
  props: ['url'],
  data () {
    return {
      model: {},
      errors: {}
    }
  },
  methods: {
    saveCategory () {
      let self = this

      this.$http
        .post(this.url + `/create`, this.model, {
          'headers': {
            'Authorization': 'Bearer ' + localStorage.getItem('token'),
            'language': this.$store.state.loading.language
          }
        }).then(res => {
          if (res.data && res.data.data !== 'undefined') {
            self.model = res.data.data
            this.$router.push('/admin/categories/index')
          } else {
            this.errors = res.response.data.errors
          }
        }).catch(res => {

        })
    }
  },
  created: function () {
    this.$emit('updateTitle', this.$translate.t('Category Create'))

    let self = this
    this.$http
      .get(this.url + `/show/0`, {
        'headers': {
          'Authorization': 'Bearer ' + localStorage.getItem('token'),
          'language': this.$store.state.loading.language
        }
      }).then(res => {
        self.model = res.data.data
      }).catch(res => {

      })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/category/CategoryCreate.vue